import React from "react";

const Container = (props) => {
  const html = document.getElementsByTagName("html")[0];
  html.setAttribute("dir", "rtl");
  html.setAttribute("lang", "ar");

  return (
    <div className="rtl container">
      <div id="page_1">
        <p dir="rtl">أحكام وشروط الاستخدام</p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> العـلاقة التعـاقدية</em>
          </li>
        </ol>
        <p dir="rtl">
          تحدد شروط وأحكام الاستخدام هذه (إلى جانب المستندات المشار إليها فيها،
          بما في ذلك بيان الخصوصية وأي شروط إضافية) ("الشروط") شروط الاستخدام
          التي يُسمح لكم على أساسها بالوصول واستخدام تطبيق "مسار" والخدمات
          الواردة فيه (معًا "الخدمات"). الخدمات مملوكة ومرخصة ومحمية بحقوق الطبع
          والنشر ويتم تشغيلها من قِبَل هداية، المركز الدولي للتميز في مواجهة
          التطرف العنيف (مع الشركات الرئيسية والفرعية، والممثلين، والشركات
          التابعة، والمسؤولين، والمديرين، لدى "هداية"). يرجى قراءة هذه الشروط
          بعناية قبل الدخول إلى الخدمات والبدء في استخدامها، حيث إنها تمثل
          اتفاقية قانونية بينكم وبين هداية. في هذه الشروط، تتضمن الكلمات "بما في
          ذلك" و"تشمل" تعني "بما في ذلك، على سبيل المثال لا الحصر".
        </p>
        <p dir="rtl">
          بالدخول إلى الخدمات أو استخدامها، فإنكم تقبلون هذه الشروط، وتوافقون
          على الالتزام بها والامتثال لها. وإذا كنتم لا توافقون على شروط
          الاستخدام هذه، فلا يجوز لكم الدخول إلى الخدمات أو استخدامها. تلغي هذه
          الشروط صراحةً الاتفاقيات أو الترتيبات السابقة معكم فيما يتعلق
          بالخدمات. يجوز لهداية على الفور دون إشعاركم، ووفقًا لتقديرها الخاص،
          إنهاء هذه الشروط أو أي خدمات تخصكم، أو التوقف بشكل عامّ عن عرض أو منع
          الوصول إلى الخدمات أو أي جزء منها، في أي وقت ولأي سبب.
        </p>
        <p dir="rtl">
          يخضع استخدامكم للخدمات أيضًا للامتثال للشروط والإرشادات الإضافية، بما
          في ذلك أي شروط تكميلية لأي خدمة (خدمات) ("الشروط الإضافية") قد يتم
          نشرها (وتعديلها) من وقت لآخر.&nbsp;
        </p>
        <p dir="rtl">
          أنتم مسؤولون عن التأكد من أن جميع الأشخاص الذين يصلون إلى الخدمات -
          بناءً على تعليماتكم أو نيابةً عنكم - على علم بهذه الشروط.&nbsp;
        </p>
        <p dir="rtl">
          <strong>هامّ</strong>: عند توقيع هذه الاتفاقية، فإنكم تقرون صراحةً
          بأنكم قد قرأتم وفهمتم تمامًا جميع شروط هذه الاتفاقية.
        </p>
        <p dir="rtl">
          يجوز لهداية تعديل الشروط من وقت لآخر. وتسري التعديلات عند نشر هداية
          لهذه الشروط المحدثة في هذا الموقع أو في أي فترات تالية. يكون أي تغيير
          من هذا القبيل ملزمًا لكم تلقائيًّا ودون قيد أو شرط، واستمرار دخولكم
          إلى الخدمات أو استخدامها بعد النشر يؤكد على موافقتكم على هذه الشروط
          المعدلة وموافقتكم على الالتزام بها والامتثال لها<strong>. </strong>
          وإذا كنتم لا توافقون على شروط الاستخدام هذه، فلا يجوز لكم الدخول إلى
          الخدمات أو استخدامها.
        </p>
        <p dir="rtl">
          يرجى التحقق من هذا الموقع والشروط التكميلية من وقت لآخر بخصوص أي
          تعديلات على هذه الشروط. أنتم مسؤولون عن ضمان الامتثال لها.&nbsp;
        </p>
        <p dir="rtl">
          بيان جمع واستخدام مجموعة هداية للمعلومات الشخصية فيما يتعلق بالخدمات
          في بيانات خصوصية هداية موجود على{" "}
          <a href="http://secure.masar.tech/privacy">
            secure.masar.tech/privacy
          </a>
          .
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> القواعد والقانون الحاكم.</em>
          </li>
        </ol>
        <p dir="rtl">
          تخضع الشروط وأي التزامات غير تعاقدية تنشأ عنها أو فيما يتعلق بها،
          لقوانين دولة الإمارات العربية المتحدة، وتفسَّر وفقًا للقوانين الخاصة
          بها، وتخضع للاختصاص القضائي الحصري لمحاكم دولة الإمارات العربية
          المتحدة.&nbsp;
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> الامتثال</em>
          </li>
        </ol>
        <p dir="rtl">
          لا تقدم هداية أي ضمانات أو تؤكد أن أيًّا من الخدمات تعتبر مناسبة للعرض
          أو قد يتم الوصول إليها بشكل قانوني من داخل الولاية القضائية التي
          تقيمون فيها في وقت استخدام أي من الخدمات.
        </p>
        <p dir="rtl">
          موافقتكم على الدخول إلى الخدمات تكون على مسؤوليتكم الخاصة. ولا تتحمل
          هداية أي عبء عن أي مسؤولية، سواء أكانت مدنية أم جنائية، ناتجة عن
          دخولكم إلى الخدمات، أو عدم قدرتكم على الوصول إليها، أو اعتمادكم على أي
          محتوى معروض كجزء من الخدمات.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> الخدمات</em>
          </li>
        </ol>
        <p dir="rtl">
          تشتمل الخدمات على تطبيقات الهاتف المحمول والخدمات ذات الصلة (كل منها
          "تطبيق")، والتي تمكِّن المستخدمين من تلقِّي معلومات حول المراقبة
          والقياس والتقييم لمنع ومكافحة برامج التطرف العنيف (P/CVE). تكون هذه
          المعلومات مصحوبة بتوصيات وتوجيهات من التطبيق للتعريف وتعزيز برنامج
          مكافحة التطرف العنيف الخاص بكم. لا تضمن هداية أن التوجيهات والمعلومات
          المقدمة ستعمل على تحسين المخرجات والنتائج وتأثير وفعالية برنامج مكافحة
          التطرف العنيف من خلال الخدمة.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> الترخيص</em>
          </li>
        </ol>
        <p dir="rtl">
          وفقًا لالتزامكم بهذه الشروط، تمنحكم هداية ترخيصًا محدودًا، وغير حصري،
          وغير قابل للترخيص من الباطن، وقابلًا للإلغاء، وغير قابل للتحويل من
          أجل: (1) الوصول إلى التطبيقات واستخدامها على جهازكم الشخصي فقط فيما
          يتعلق باستخدامكم للخدمات؛ وكذلك (2) الوصول إلى واستخدام أي محتوى
          ومعلومات ومواد ذات صلة قد يتم توفيرها من خلال الخدمات، في كل حالة فقط
          لاستخدامكم الشخصي وغير التجاري. جميع الحقوق غير الممنوحة هنا صراحةً
          محفوظة لهداية ومرخصي هداية. إذا قمتم بطباعة أو نسخ أو تنزيل أي جزء من
          الخدمات بما يخالف هذه الشروط، فسوف يتوقف حقكم في استخدام الخدمات على
          الفور ويجب عليكم، بناءً على خيارنا، إعادة أو إتلاف أي نسخ من المواد
          قمتم بعملها.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> القيود.</em>
          </li>
        </ol>
        <p dir="rtl">
          بالموافقة على هذه الشروط، لا يجوز لكم: (1) إزالة أي حقوق نشر أو علامة
          تجارية أو إشعارات ملكية أخرى من أي جزء من الخدمات؛ (2) إعادة إنتاج
          الأعمال المشتقة، أو تعديلها، أو إعدادها بناءً على الخدمات، أو توزيعها،
          أو ترخيصها، أو استئجارها، أو بيعها، أو إعادة بيعها، أو نقلها، أو عرضها
          علنًا، أو تقديمها للجمهور، أو نقلها، أو بثها، أو إذاعتها، أو نشرها، أو
          استغلالها بخلاف ما تسمح به هداية صراحةً؛ (3) تجزئة الخدمات أو إجراء
          هندسة عكسية لها أو تفكيكها باستثناء ما يسمح به القانون المعمول به؛ (4)
          ربط أي جزء من الخدمات أو عكسه أو تأطيره؛ (5) التسبب في أو إطلاق أي
          برامج أو نصوص برمجية لغرض كشط، أو فهرسة، أو مسح، أو استخراج البيانات
          بأي جزء من الخدمات، أو إعاقة، أو عرقلة تشغيل و/أو وظيفة أي جانب من
          جوانب الخدمات دون مبرر؛ أو (6) محاولة الوصول غير المصرح به إلى أي جانب
          من جوانب الخدمات أو الأنظمة أو الشبكات ذات الصلة أو إفسادها.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> خدمات ومحتوى الطرف الثالث.</em>
          </li>
        </ol>
        <p dir="rtl">
          قد يتم توفير الخدمات أو الوصول إليها فيما يتعلق بخدمات ومحتويات الطرف
          الثالث التي لا تسيطر عليها هداية. وتقرون أنتم بأن شروط الاستخدام
          وسياسات الخصوصية المختلفة قد تنطبق على استخدامكم لخدمات ومحتويات الطرف
          الثالث. لا تصدق هداية على خدمات ومحتويات الطرف الثالث، ولا تتحمل بأي
          حال من الأحوال العبء أو المسؤولية عن أي منتجات أو خدمات لمقدمي الطرف
          الثالث. وبالإضافة إلى ذلك، تكون شركة Apple Inc.، أو Google Inc.، أو
          Microsoft Corporation، أو BlackBerry Limited مستفيدة بصفتها طرفًا ثالث
          في هذا العقد إذا قمتم بالدخول إلى الخدمات باستخدام التطبيقات المطورة
          لأجهزة Apple iOS، أو Android، أو Microsoft Windows، أو Blackberry،
          التي تقدمها هذه الشركات على التوالي. هؤلاء الأطراف الثلاثة المستفيدون
          ليسوا أطرافًا في هذا العقد وليسوا مسؤولين عن توفير أو دعم الخدمات بأي
          شكل من الأشكال. يخضع دخولكم إلى الخدمات باستخدام هذه الأجهزة للشروط
          المنصوص عليها في شروط خدمة الطرف الثالث المستفيد المعمول بها.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> الملكية.</em>
          </li>
        </ol>
        <p dir="rtl">
          الخدمات وجميع الحقوق المنصوص عليها هنا هي ملك هداية وستظل كذلك. لا هذه
          الشروط ولا استخدامكم للخدمات ينقل أو يمنحكم أي حقوق: (1) في الخدمات أو
          ما يتعلق بها باستثناء الترخيص المحدود الممنوح أعلاه؛ أو (2) استخدام أو
          الإشارة بأي شكل من الأشكال إلى أسماء الشركات، والشعارات، وأسماء
          المنتجات، والخدمات، والعلامات التجارية، أو علامات الخدمات، أو تلك
          الخاصة بمرخصي هداية بأي شكل من الأشكال.
        </p>
        <p dir="rtl">
          لا يجوز لكم استخدام أي رسوم توضيحية، أو صور، أو مقاطع فيديو، أو مسارات
          صوتية، أو أي رسومات بشكل منفصل عن أي نص مصاحب دون موافقة كتابية مسبقة.
          يجب دومًا الإقرار بوضع هداية (وحالة أي مساهم محدد) كمؤلفي المحتوى على
          الخدمات.
        </p>
        <p dir="rtl">
          يحظر عليكم استخدام أي جزء من الخدمات لأغراض تجارية دون الحصول على
          ترخيص للقيام بذلك من هداية (إن وجد) أو مرخصي هداية.&nbsp;
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> حسابات المستخدِم</em>
          </li>
        </ol>
        <p dir="rtl">
          يجب عليكم التسجيل للحصول على حساب خدمات مستخدم شخصي نشط ("الحساب")
          والاحتفاظ به لتتمكنوا من استخدام معظم جوانب الخدمات. عند قبول هذه
          الشروط، فإنكم تقرون بأن عمركم لا يقل عن 18 عامًا، أو سن الرشد القانوني
          في نطاق ولايتكم القضائية (إذا كان أكبر من 18 عامًا)، للحصول على حساب،
          ما لم تسمح خدمة معينة بخلاف ذلك. يتطلب تسجيل الحساب أن تقدموا إلى
          هداية معلومات شخصية معينة، مثل الاسم، والعنوان، ورقم الهاتف المحمول،
          والعمر. وتوافقون على الاحتفاظ بمعلومات دقيقة وكاملة وحديثة في حسابكم.
          قد يؤدي فشلكم في الاحتفاظ بمعلومات حساب دقيقة وكاملة وحديثة إلى عدم
          قدرتكم على الوصول إلى الخدمات أو استخدامها. أنتم مسؤولون عن جميع
          الأنشطة التي تحدث في حسابكم، وتوافقون على الحفاظ على أمان وسرية اسم
          المستخدم وكلمة المرور لحسابكم في جميع الأوقات. إذا عرفتم أو شككتم بأن
          أي شخص بخلافكم يعرف اسم المستخدم أو كلمة مرور المستخدم، فيجب عليكم
          إبلاغنا على الفور.&nbsp;
        </p>
        <p dir="rtl">
          يحق لهداية تعطيل أي رمز تعريف أو كلمة مرور للمستخدم، سواء أتم اختياره
          من قبلكم أو تم تخصيصه من قبلنا، في أي وقت، إذا قررنا، وفقًا لتقديرنا
          الخاص، أو اعتقدنا أنكم فشلتم في الامتثال لأي من أحكام هذه الشروط.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> متطلبات المستخدم وسلوكه.</em>
          </li>
        </ol>
        <p dir="rtl">
          الخدمة غير متاحة للاستخدام من قِبَل الأشخاص الذين تقل أعمارهم عن 18
          عامًا. ولا يجوز لكم تفويض أطراف ثالثة لاستخدام حسابكم، ولا يجوز لكم
          السماح للأشخاص الذين تقل أعمارهم عن 18 عامًا بالوصول إلى الخدمات أو
          استخدامها. لا يجوز لكم التنازل عن حسابكم أو نقله إلى أي شخص أو كيان
          آخر. وتوافقون على الامتثال لجميع القوانين المعمول بها عند الوصول إلى
          الخدمات أو استخدامها، ويجوز لكم فقط الوصول إلى الخدمات أو استخدامها
          لأغراض قانونية. في حالات معينة، قد يُطلب منكم تقديم إثبات هوية أو
          طريقة أخرى للتحقق من الهوية للوصول إلى الخدمات أو استخدامها، وتوافقون
          على أنه قد يتم رفض وصولكم إلى الخدمات أو استخدامها إذا رفضتم تقديم
          إثبات هوية أو غير ذلك من طرق التحقق من الهوية.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> المحتوى المقدم من المستخدم.</em>
          </li>
        </ol>
        <p dir="rtl">
          يجوز لهداية، حسب تقدير هداية وحدها، أن تسمح لكم من وقت لآخر بإرسال، أو
          تحميل، أو نشر، أو إتاحة من خلال "مسار" محتوى ومعلومات نصية و/أو صوتية
          و/أو مرئية، بما في ذلك التعليقات والمراجعات المتعلقة بالخدمات، وبدء
          دعم الطلبات، وتقديم إدخالات للمسابقات والعروض الترويجية ("محتوى
          المستخدم"). أي محتوى مستخدِم مقدم من طرفكم يبقى ملكًا لكم. ومع ذلك، من
          خلال تقديم محتوى المستخدم إلى هداية، فإنكم تمنحون هداية ترخيصًا شاملًا
          ودائمًا، وغير قابل للإلغاء، وقابلًا للتحويل، وخاليًا من حقوق الملكية،
          مع الحق في الترخيص من الباطن لاستخدام ونسخ وتعديل وإنشاء أعمال مشتقة
          منه، وتوزيعه وعرضه علنًا، وعرض واستخدام محتوى المستخدم بأي شكل من
          الأشكال في جميع الأشكال وقنوات التوزيع المعروفة الآن أو التي يتم
          ابتكارها (بما في ذلك ما يتعلق بالخدمات وأعمال هداية، وعلى مواقع وخدمات
          الطرف الثالث)، دون إشعار أو موافقة منكم، وبدون شرط السداد لكم أو لأي
          شخص أو كيان آخر. وفقًا لتقدير هداية، يجوز لهداية أيضًا منح طرف ثالث حق
          الوصول إلى محتوى المستخدم الذي تم جمعه فيما يتعلق بالخدمات. قد تشمل
          الأطراف الثالثة التي لديها حق الوصول إلى هذه المعلومات المعهد الملكي
          للخدمات المتحدة وحكومة كندا و21 يونيكورن.&nbsp;
        </p>
        <p dir="rtl">
          تقرون وتضمنون ما يلي: (1) أنكم المالك الوحيد والحصري لجميع محتوى
          المستخدم، أو أن لديكم جميع الحقوق والتراخيص والموافقات والإصدارات
          اللازمة لمنح هداية الترخيص لمحتوى المستخدم كما هو موضح أعلاه؛ و(2) لا
          محتوى المستخدم، ولا إرسالكم أو تحميله، أو نشره، أو إتاحته لمحتوى
          المستخدم هذا، أو استخدام هداية لمحتوى المستخدم على النحو المسموح به
          هنا سوف يخالف أو يسيء أو ينتهك حقوق الملكية الفكرية أو حقوق الملكية
          الخاصة بطرف ثالث، أو حقوق الدعاية أو الخصوصية، أو يَنتِج عنها انتهاك
          لأي قانون أو لائحة سارية. سوف تكونون مسؤولين أمامنا وتعويضنا عن أي خرق
          للضمان والتعهد أعلاه وفقًا للقسم 14 أدناه. وهذا يعني أنكم ستكونون
          مسؤولين عن أي خسارة أو ضرر نتعرض له نتيجة لخرقكم للضمان.
        </p>
        <p dir="rtl">
          توافقون على عدم تقديم محتوى المستخدم الذي يعتبر تحقيريًّا، أو
          تشهيريًّا، أو يحض على الكراهية، أو عنيفًا، أو فاحشًا، أو إباحيًّا، أو
          غير قانوني، أو مهينًا بأي شكل آخر، وفقًا لما تحدده هداية حسب تقديرها
          الخاص، سواء أكانت هذه المواد محمية بموجب القانون أم لا. يجوز لهداية،
          ولا تكون ملزمة، بمراجعة محتوى المستخدم أو مراقبته أو إزالته، وفقًا
          لتقدير هداية وحدها وفي أي وقت ولأي سبب، دون إشعاركم.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> الوصول إلى الشبكة والأجهزة.</em>
          </li>
        </ol>
        <p dir="rtl">
          أنتم مسؤولون عن الحصول على الوصول إلى شبكة البيانات اللازمة لاستخدام
          الخدمات. قد تطبق أسعار ورسوم شبكة الهاتف المحمول الخاصة بكم إذا قمتم
          بالوصول إلى الخدمات أو استخدامها من جهازكم. أنتم مسؤولون عن الحصول على
          الأجهزة أو الأجهزة المتوافقة وتحديثها اللازم للوصول إلى الخدمات
          والتطبيقات واستخدامها وأي تحديثات لها. لا تضمن هداية أن الخدمات، أو أي
          جزء منها، ستعمل على أي أجهزة أو أجهزة معينة. وبالإضافة إلى ذلك، قد
          تخضع الخدمات لأعطال وتأخيرات ناتجة عن استخدام الإنترنت والاتصالات
          الإلكترونية.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> إخلاء المسؤولية؛ تحديد المسؤولية</em>
          </li>
        </ol>
        <p dir="rtl">
          <em dir="rtl">إخلاء المسؤولية.</em>
        </p>
        <p dir="rtl">
          يتم توفير الخدمات على أساس "على حالها" و"كما هي متاحة". إلى الحد الذي
          يسمح به القانون، تستبعد هداية جميع الإقرارات، أو التعهدات، أو
          الضمانات، أو الشروط، أو الشروط الأخرى التي قد تنطبق على الخدمات، سواء
          أكانت صريحة أم ضمنية أم قانونية، فيما يتعلق بالخدمات، بما في ذلك أي
          إقرار أو تعهد أو ضمان فيما يتعلق بالخدمات بشأن قابلية التسويق واللياقة
          لغرض معين وعدم المخالفة. وبالإضافة إلى ذلك، لا تقدم هداية أي إقرار أو
          تعهد أو ضمان، سواء أكان صريحًا أم ضمنيًّا أم قانونيًّا، فيما يتعلق
          بالاكتمال، أو الدقة، أو الموثوقية، أو حسن التوقيت، أو الجودة، أو
          الملاءمة، أو توفر الخدمات، أو أي خدمات أو سلع مطلوبة من خلال استخدام
          الخدمات، أو أن الخدمات ستكون بلا انقطاع أو خالية من الأخطاء وليست
          ملزمة بتحديث أو تصحيح أي خدمة أو معلومات قد تكون قديمة، أو غير مكتملة،
          أو غير دقيقة. لا تقر هداية أو تتعهد أو تضمن جودة أو ملاءمة أو قدرة
          مزودي الطرف الثالث ومساهمتهم في الخدمات. وتوافقون على أن المخاطر
          الكاملة الناشئة عن استخدامكم للخدمات، وأي خدمة أو سلعة مطلوبة فيما
          يتعلق بها، تظل على عاتقكم وحدكم، إلى أقصى حد يسمح به القانون.
        </p>
        <p dir="rtl">
          <em dir="rtl">عدم الاعتماد على المعلومات.</em>
        </p>
        <p dir="rtl">
          يتم توفير الخدمات لأغراض المعلومات العامة فقط. وليس المقصود منها أن
          تكون بمثابة نصائح ينبغي عليكم الاعتماد عليها. يجب أن تحصلوا على مشورة
          مهنية أو متخصصة قبل اتخاذ أي إجراء على أساس الخدمات والمعلومات الواردة
          فيها، أو الامتناع عن ذلك.&nbsp;
        </p>
        <p dir="rtl">
          <em dir="rtl">تحديد المسؤولية.</em>
        </p>
        <p dir="rtl">
          لا تتضمن شروط الاستخدام هذه أي شيء يستبعد أو يقيد مسؤوليتنا عن حالات
          الوفاة أو الإصابة الشخصية الناجمة عن إهمال أو تزوير أو احتيال من
          جانبنا، أو أي مسؤولية أخرى لا يمكن استبعادها أو تقييدها بموجب القانون
          المعمول به.&nbsp;
        </p>
        <p dir="rtl">
          لن تكون هداية مسؤولة تجاه أي مستخدم للخدمات عن الأضرار غير المباشرة،
          أو العرضية، أو الخاصة، أو التحذيرية، أو العقابية، أو التبعية، بما في
          ذلك الأرباح الضائعة، أو البيانات المفقودة، أو انقطاع الأعمال التجارية،
          أو فرص الأعمال الضائعة، أو الشهرة، أو السمعة المتعلقة أو الناتجة عن أي
          استخدام للخدمات، بغض النظر عن الإهمال (سواء أكان نشطًا، أم إيجابيًّا،
          أم منفردًا، أم متزامنًا) من هداية، حتى إذا تم إبلاغ هداية بإمكانية
          حدوث مثل هذه الأضرار أو كان من الممكن توقع مثل هذه الأضرار بشكل معقول.
        </p>
        <p dir="rtl">
          لن تكون هداية مسؤولة عن أي أضرار أو مسؤولية أو خسائر ناشئة عن: (1)
          استخدامكم للخدمات أو الاعتماد عليها، أو عدم قدرتكم على الوصول إلى
          الخدمات أو استخدامها؛ أو (2) أي معاملة أو علاقة بينكم وبين أي جهة
          خارجية.
        </p>
        <p dir="rtl">
          بينما تهتم هداية بشكل معقول بإدارة الخدمات، فإننا لا نضمن أن الخدمات
          أو التطبيقات ستكون آمنة أو خالية من الأخطاء أو الفيروسات. وتتحملون
          أنتم مسؤولية تعريف تكنولوجيا المعلومات وبرامج الكمبيوتر والمنصة الخاصة
          بكم للوصول إلى موقعنا. وينبغي عليكم استخدام برامجكم الخاصة للحماية من
          الفيروسات. لن نتحمل المسؤولية عن أي خسارة أو ضرر ناجم عن فيروس أو هجوم
          رفض الخدمة الموزعة أو غيرها من المواد الضارة من الناحية التكنولوجية
          التي قد تصيب معدات الكمبيوتر، أو برامج الكمبيوتر، أو البيانات، أو
          غيرها من المواد الخاصة بسبب استخدامكم لموقعنا أو تنزيلكم لأي محتوى
          موجود عليه، أو على أي موقع مرتبط به.&nbsp;
        </p>
        <p dir="rtl">
          يجب عليكم عدم إساءة استخدام موقعنا من خلال تعمد إدخال الفيروسات، أو
          أحصنة طروادة، أو فيروسات الدودة، أو القنابل المنطقية، أو أي مواد أخرى
          خبيثة أو ضارة من الناحية التكنولوجية. ولا يجوز لكم محاولة الوصول غير
          المصرح به إلى الخدمات، أو التطبيقات، أو أي خادم أو كمبيوتر أو قاعدة
          بيانات متصلة بالخدمات أو التطبيقات أو مستخدمة فيما يتعلق بها. ويجب
          عليكم عدم مهاجمة موقعنا عن طريق هجوم رفض الخدمة أو هجوم رفض الخدمة
          الموزعة. وسنقوم بإبلاغ السلطات المعنية بإنفاذ القوانين تجاه أي مخالفة
          من هذا القبيل، وسوف نتعاون مع هذه السلطات عن طريق كشف هويتكم لها. وفي
          حالة حدوث انتهاك من هذا القبيل، سوف يتوقف حقكم في استخدام موقعنا على
          الفور.
        </p>
        <p dir="rtl">
          نحن لا نتحمل أي مسؤولية عن محتوى أي مواقع مرتبطة بموقع "مسار". ولا
          ينبغي تفسير مثل هذه الروابط باعتبارها نوعًا من المصادقة من جانبنا على
          مواقع الويب المرتبطة هذه. ولن نتحمل مسؤولية أي خسارة أو ضرر قد ينشأ عن
          استخدامكم لها.&nbsp;
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> التعويض.</em>
          </li>
        </ol>
        <p dir="rtl">
          توافقون على حماية وتعويض هداية والشركات التابعة لها، ومسؤوليها،
          ومديريها، وموظفيها، ووكلائها عن أضرارها وضد أي وجميع الطلبات
          والمطالبات والخسائر والخصوم والنفقات (بما في ذلك أتعاب المحاماة) التي
          تكلفتها أو تكبدتها (بشكل مباشر أو غير مباشر) إلى المدى الناشئ عن، أو
          المرتبط، أو فيما يتعلق بما يلي: (1) استخدامكم للخدمات أو الخدمات أو
          السلع التي تم الحصول عليها من خلال استخدامكم للخدمات؛ (2) خرقكم أو
          انتهاككم لأي من هذه الشروط؛ (3) استخدام هداية لمحتوى المستخدم الخاص
          بكم؛ أو (4) انتهاككم لحقوق أي طرف ثالث، بما في ذلك مزودو خدمة الطرف
          الثالث.
        </p>
        <ol>
          <li dir="rtl">
            <em dir="rtl"> بشكل عامّ.</em>
          </li>
        </ol>
        <p dir="rtl">
          لا يجوز لكم التنازل عن هذه الشروط دون موافقة كتابية مسبقة من هداية.
          ويجوز لهداية التنازل عن هذه الشروط دون موافقتكم إلى: (1) شركة فرعية أو
          تابعة؛ (2) حيازة أسهم أو أعمال أو أصول هداية؛ أو (3) خليفة عن طريق
          الاندماج. أي تنازل مزعوم يخالف هذا القسم يعتبر باطلًا. لا توجد علاقة
          مشتركة أو شراكة أو توظيف أو علاقة وكالة بينكم وبين هداية أو أي جهة
          خارجية نتيجة لهذه الشروط أو استخدام الخدمات. إذا تم اعتبار أي بند من
          هذه الشروط غير صالح أو غير قابل للتنفيذ، فسيتم تطبيق هذا البند مع الحد
          الأدنى من التعديلات اللازمة لجعله صالحًا وملزمًا وقابلًا للتنفيذ، ويتم
          تنفيذ الأحكام المتبقية إلى أقصى حد يسمح به القانون. إن تأخُّر هداية أو
          فشلها في تنفيذ أي حق أو حكم في هذه الشروط لا يشكل تنازلًا عن هذا الحق
          أو الحكم ما لم تعترف به هداية وتوافق عليه كتابةً. لا يؤثر هذا الحكم في
          قسم الاستقلالية وبقاء الأثر في اتفاقية التحكيم لهذه الشروط.
        </p>
        <p dir="rtl">بيان الخصوصية</p>
        <p dir="rtl">
          يوضح بيان الخصوصية هذا ممارساتنا، بما في ذلك حقوقكم، فيما يتعلق بجمع
          واستخدام وإفشاء معلومات معينة، بما في ذلك معلوماتكم الشخصية، بواسطة
          هداية، المركز الدولي للتميز في مواجهة التطرف العنيف (مع الشركات
          الرئيسية، والشركات الفرعية، والممثلين، والشركات التابعة، والمسؤولين،
          والمديرين، لدى "هداية")، مع الإشارة إلى وصولكم واستخدامكم لتطبيق
          "مسار" والخدمات الواردة فيه (معًا "الخدمات").
        </p>
        <p dir="rtl">
          <em dir="rtl">الاتصال بنا</em>
        </p>
        <p dir="rtl">
          إذا كانت لديكم أسئلة عامة حول حسابكم أو كيفية الاتصال بخدمة العملاء
          للحصول على المساعدة، يرجى زيارة الصفحة contact{" "}
          <a href="mailto:masar@hedayah.ae">masar@hedayah.ae</a> ، وبالنسبة
          للأسئلة الخاصة ببيان الخصوصية هذا، أو استخدامنا لمعلوماتكم الشخصية أو
          ملفات تعريف الارتباط أو التقنيات المماثلة، يرجى الاتصال بنا عبر البريد
          الإلكتروني على{" "}
          <a href="mailto:privacy@masar.tech">masar@hedayah.ae</a>&nbsp;
        </p>
        <p dir="rtl">
          المتحكم في بيانات معلوماتكم الشخصية هي هداية، وهي التي توفر لكم أيضًا
          الخدمة. يرجى ملاحظة أنه إذا اتصلتم بنا لمساعدتكم، من أجل سلامتكم
          وسلامتنا، فقد نحتاج إلى توثيق هويتكم قبل تلبية طلبكم.
        </p>
        <p dir="rtl">
          <em dir="rtl">جمع المعلومات</em>
        </p>
        <p dir="rtl">
          هداية مسؤولة عن معالجة البيانات الشخصية والتنظيمية في إطار الخدمات
          المبينة في هذه الشروط. تجمع هداية وتخزن الأنواع التالية من المعلومات
          الشخصية عنكم عندما تصل إلى الخدمات:<strong></strong>
        </p>
        <p dir="rtl">
          المعلومات التي تقدمونها لنا<strong>:</strong> نقوم بجمع المعلومات
          الشخصية التي تقدموها لنا والتي تشمل:
        </p>
        <ul>
          <ul>
            <li dir="rtl">
              الاسم، وعنوان بريدكم الإلكتروني، وعنوانكم، أو الرمز البريدي، ورقم
              الهاتف، والجنس، وبيانات الميلاد/العمر، والجنسية، واللقب، واسم
              المستخدم، وكلمة المرور. نحن نجمع هذه المعلومات بعدد من الطرق، بما
              في ذلك عند إدخالها أثناء استخدام الخدمات، أو التفاعل مع خدمة
              العملاء لدينا، أو المشاركة في الاستطلاعات أو العروض الترويجية
              التسويقية؛ وكذلك
            </li>
            <li dir="rtl">
              معلومات عن مؤسستكم، ودوركم داخل مؤسستكم، والاسم، والعنوان، ورقم
              الهاتف، وعنوان البريد الإلكتروني لصاحب العمل، إلى الحد المناسب،
              وتفاصيل شاملة حول برامجكم الخاصة بمنع ومكافحة التطرف العنيف
              (P/CVE) التي تقومون بها أنتم أو مؤسستكم. نجمع هذه المعلومات بعدد
              من الطرق، بما في ذلك عند تحميلها إلى حسابكم، أو تقديم معلومات لنا
              بطريقة أخرى من خلال الخدمات أو في أي مكان آخر.
            </li>
          </ul>
          <li dir="rtl">
            المعلومات التي نجمعها تلقائيًّا<strong>:</strong> نحن نجمع معلومات
            شخصية عنكم وعن استخدامكم للخدمات، وتفاعلاتكم معنا ومع إعلاناتنا،
            بالإضافة إلى معلومات تتعلق بجهاز الكمبيوتر الخاص بكم أو أي جهاز آخر
            يستخدم للوصول إلى خدمتنا (مثل أنظمة الألعاب وأجهزة التلفاز الذكية،
            والأجهزة المحمولة، وأجهزة الاستقبال). تتضمن هذه المعلومات:
          </li>
          <ul>
            <li dir="rtl">نشاطكم على تطبيق "مسار"؛</li>
            <li dir="rtl">
              تفاصيل تفاعلاتكم مع خدمة العملاء، مثل تاريخ ووقت وسبب الاتصال بنا،
              ونصوص أي محادثات دردشة، وإذا اتصلتم بنا، ورقم هاتفكم وتسجيلات
              المكالمات؛
            </li>
            <li dir="rtl">
              معرفات الجهاز أو غيرها من المعرّفات الفريدة، وخصائص الجهاز
              والبرامج (مثل النوع والتكوين)، ومعلومات الاتصال، والإحصاءات حول
              مشاهدات الصفحة، وعناوين URL للإحالة، وعنوان IP (الذي قد يخبرنا عن
              موقعكم العام)، والمتصفح، ومعلومات سجل خادم الويب القياسية؛ وكذلك
            </li>
            <li dir="rtl">
              المعلومات التي يتم جمعها عبر استخدام ملفات تعريف الارتباط وإشارات
              الويب والتقنيات الأخرى، بما في ذلك بيانات الإعلان (مثل المعلومات
              حول توفر الإعلانات وعرضها وعنوان URL الخاص بالموقع، بالإضافة إلى
              التاريخ والوقت).&nbsp;
            </li>
          </ul>
          <li dir="rtl">
            معلومات من مصادر أخرى<strong>:</strong> قد نكمل المعلومات الشخصية
            الموضحة أعلاه بالمعلومات الشخصية التي نحصل عليها من مصادر أخرى، بما
            في ذلك من كل من مزودي البيانات عبر الإنترنت وغيره ومن مزودي خدمة
            الطرف الثالث. يمكن أن تتضمن هذه المعلومات الشخصية التكميلية البيانات
            الديموغرافية، والبيانات القائمة على الاهتمامات، وأي وجهات نظر وآراء
            تختارون نشرها علانية عنا على منصات وسائل التواصل الاجتماعي وسلوك
            تصفح الإنترنت.
          </li>
          <li dir="rtl">
            إنشاء المعلومات الشخصية<strong>: </strong>نقوم أيضًا بإنشاء معلومات
            شخصية عنكم في ظروف معينة، مثل سجلات تفاعلاتكم معنا وتفاصيل سجل
            الشراء.
          </li>
        </ul>
        <p dir="rtl">
          <em dir="rtl">المعلومات الشخصية الحساسة</em>
        </p>
        <p dir="rtl">
          نحن لا نسعى لجمع أو معالجة المعلومات الشخصية الحساسة (كما هو موضح
          أدناه) في المسار العادي لأعمالنا. عندما يصبح من الضروري معالجة
          معلوماتكم الشخصية الحساسة لأي سبب، فإننا نعتمد على أحد القواعد
          القانونية التالية:
        </p>
        <ul>
          <li dir="rtl">
            الامتثال للقانون المعمول به<strong>:</strong> قد نقوم بمعالجة
            معلوماتكم الشخصية الحساسة عندما تكون المعالجة مطلوبة أو مسموحًا بها
            بموجب القانون المعمول به (على سبيل المثال الامتثال لالتزاماتنا
            المتعلقة بإعداد تقارير التنوع).
          </li>
          <li dir="rtl">
            كشف ومنع الجريمة<strong>:</strong> قد نقوم بمعالجة معلوماتكم الشخصية
            الحساسة عندما تكون المعالجة ضرورية للكشف عن الجريمة أو منعها (على
            سبيل المثال منع الاحتيال).
          </li>
          <li dir="rtl">
            إنشاء أو ممارسة أو الدفاع عن الحقوق القانونية<strong>:</strong> قد
            نقوم بمعالجة معلوماتكم الشخصية الحساسة عندما تكون المعالجة ضرورية
            لإنشاء الحقوق القانونية، أو ممارستها، أو الدفاع عنها.
          </li>
          <li dir="rtl">
            الموافقة<strong>:</strong> يجوز لنا معالجة معلوماتكم الشخصية الحساسة
            حيث حصلنا، وفقًا للقانون المعمول به، على موافقتكم المسبقة والصريحة
            قبل معالجة معلوماتكم الشخصية الحساسة (يُستخدم هذا الأساس القانوني
            فقط فيما يتعلق بمعالجة تطوعية تمامًا - لا يتم استخدامها لمعالجة ما
            هو ضروري أو إلزامي بأي شكل من الأشكال).
          </li>
        </ul>
        <p dir="rtl">
          إذا قدمتم معلومات شخصية حساسة لنا، يجب عليكم التأكد من أنه مصرح لكم
          قانونًا بالكشف عن هذه البيانات، ويجب عليكم التأكد من أن هناك أساسًا
          قانونيًّا صالحًا ينطبق على معالجة تلك المعلومات الشخصية الحساسة.
        </p>
        <p dir="rtl">
          <em dir="rtl">
            لأغراض بيان الخصوصية هذا، تعني "المعلومات الشخصية الحساسة" المعلومات
            الشخصية المتعلقة بالعِرق، أو الأصل، أو الآراء السياسية، أو المعتقدات
            الدينية أو الفلسفية، أو عضوية النقابات العمالية، أو الصحة البدنية أو
            العقلية، أو الحياة الجنسية، أو أي مخالفات أو عقوبات فعلية أو مزعومة،
            أو رقم الهوية الوطنية، أو أي معلومات أخرى تعتبر حساسة بموجب القانون
            المعمول به.
          </em>
        </p>
        <p dir="rtl">
          <em dir="rtl">استخدام المعلومات</em>
        </p>
        <p dir="rtl">
          نستخدم معلوماتكم الشخصية لعدد من الأغراض، وفقًا للقانون المعمول به،
          بما في ذلك:
        </p>
        <ul>
          <li dir="rtl">توفير الخدمات، وتحليلها، وإدارتها، وتعزيزها، وتخصيصها،&nbsp;</li>
          <li dir="rtl">
            تحديد برامج مكافحة التطرف العنيف ذات الصلة التي تعد أمثلة على
            الممارسات الجيدة أو الدروس المستفادة في هذا المجال،
          </li>
          <li dir="rtl">
            الإبلاغ عن تطوير وتصميم برامج مكافحة الطرف العنيف المستقبلية،&nbsp;
          </li>
          <li dir="rtl">
            التواصل معكم للاستفادة من برنامج مكافحة الطرف العنيف كدراسة حالة أو
            كمثال للممارسة الجيدة (ملاحظة: يجب منح موافقتكم لمسار وهداية قبل نشر
            بياناتكم)،
          </li>
          <li dir="rtl">تحسين منتج مسار،&nbsp;</li>
          <li dir="rtl">
            إدارة وتشغيل أنظمة الاتصالات وتكنولوجيا المعلومات والأمن لدينا؛
            والتدقيق (بما في ذلك التدقيق الأمني) ورصد هذه الأنظمة،&nbsp;
          </li>
          <li dir="rtl">التواصل معكم بغرض الحصول على آرائكم حول خدماتنا،&nbsp;</li>
          <li dir="rtl">
            الكشف عن انتهاكات السياسة والجرائم الجنائية والتحقيق فيها ومنعها،
            وفقًا للقانون المعمول به،&nbsp;
          </li>
          <li dir="rtl">إنشاء وممارسة الحقوق القانونية والدفاع عنها،&nbsp;</li>
        </ul>
        <ul>
          <li dir="rtl">
            الامتثال لالتزاماتنا القانونية والتنظيمية بموجب القانون المعمول به،
          </li>
          <li dir="rtl">
            تحديد موقعكم الجغرافي العامّ، وتوفير المحتوى المترجم، وتزويدكم
            بتوصيات مخصصة وشخصية لموارد وعناصر المكتبة؛
          </li>
          <li dir="rtl">
            تحليل وفهم جمهورنا، وتحسين الخدمات (بما في ذلك تجارب واجهة المستخدم
            لدينا) وتحسين تجربة المستخدم وخوارزميات التوصيات والتسليم؛
          </li>
          <li dir="rtl">
            التواصل معكم بشأن الخدمات (على سبيل المثال عن طريق البريد الإلكتروني
            والرسائل النصية عبر الإشعارات المباشرة وقنوات المراسلة عبر
            الإنترنت)؛ حتى نتمكن من إرسال أخبار إليكم عن مسار وتفاصيل حول
            الميزات الجديدة والمحتوى المتاح على مسار، والعروض الخاصة والإعلانات
            الترويجية واستطلاعات المستهلك، وتخضع دائمًا للحصول على الموافقة
            المسبقة منكم إلى الحد المطلوب بموجب القانون المعمول به، ولمساعدتكم
            في الطلبات التشغيلية مثل طلبات إعادة تعيين كلمة المرور.&nbsp;
          </li>
        </ul>
        <p dir="rtl">
          <em dir="rtl">الأساس القانوني للمعالجة</em>
        </p>
        <p dir="rtl">
          أثناء معالجة معلوماتكم الشخصية فيما يتعلق بالأغراض المحددة في بيان
          الخصوصية هذا، قد نعتمد على واحدة أو أكثر من القواعد القانونية التالية،
          وفقًا للظروف:
        </p>
        <ul>
          <li dir="rtl">
            <em dir="rtl">
              <em dir="rtl">
                إذا كانت المعالجة ضرورية فيما يتعلق بأي عقد أبرمتموه معنا، أو
                لاتخاذ خطوات قبل الدخول في عقد معنا؛
              </em>
            </em>
          </li>
        </ul>
        <ul>
          <li dir="rtl">
            <em dir="rtl">
              إذا كانت لدينا مصلحة مشروعة في تنفيذ المعالجة لغرض: (1) تقديم أو
              تحسين خدماتنا؛ (2) الوفاء بالتزاماتنا التنظيمية والامتثال؛ (3)
              الاتصال بكم، مع مراعاة الالتزام دائمًا بالقانون المعمول به؛
              (رابعًا) اكتشاف انتهاكات سياساتنا والقوانين المعمول بها والحماية
              منها؛ أو (5) إنشاء أو ممارسة أو الدفاع عن حقوقنا القانونية (إلى
              الحد الذي لا تتجاوز فيه هذه المصلحة المشروعة مصالحكم أو حقوقكم
              الأساسية أو حرياتكم)؛
            </em>
          </li>
        </ul>
        <ul>
          <li dir="rtl">
            <em dir="rtl">
              عند حصولنا على موافقتكم المسبقة على المعالجة (يتم استخدام هذا
              الأساس القانوني فقط فيما يتعلق بالمعالجة الطوعية تمامًا - ولا يتم
              استخدامها للمعالجة الضرورية أو الإلزامية بأي شكل من الأشكال)؛ أو
            </em>
          </li>
        </ul>
        <ul>
          <li dir="rtl">
            <em dir="rtl">إذا كانت المعالجة ضرورية للامتثال لالتزام قانوني.</em>
          </li>
        </ul>
        <p dir="rtl">
          <em dir="rtl">كشف المعلومات</em>
        </p>
        <p dir="rtl">
          نكشف عن معلوماتكم الشخصية إلى كيانات أخرى ضمن مجموعة هداية وفقًا
          للقانون المعمول به، لأغراض تجارية مشروعة معينة وتشغيل خدماتنا،
          وللأطراف الثالثة، كما هو موضح أدناه:<strong></strong>
        </p>
        <p dir="rtl">
          المعهد الملكي للخدمات المتحدة (RUSI)<strong>:</strong> نظرًا لأن RUSI
          هي منظمة شريكة في هذا المشروع، يجوز لهداية أن تقدم، وفقًا لتقديرها، أي
          معلومات خاصة تحصل عليها إلى RUSI. يتم الكشف عن هذه المعلومات دون
          موافقة مسبقة من المستخدم، ولكن وفقًا لقوانين الخصوصية المعمول بها،
          والقانون الدولي، ومعايير حقوق الإنسان ومبادئ "عدم الضرر". لن تقوم RUSI
          بتمرير أي بيانات شخصية إلى أطراف ثالثة ولن تستخدم سوى المعلومات الخاصة
          للغرض الوحيد من هذا المشروع;
        </p>
        <p dir="rtl">
          21 يونيكورن<strong>: </strong>بما أن 21 يونيكورن هو مطور التطبيقات
          لمسار، فقد توفر هداية، حسب تقديرها، الوصول إلى أي معلومات خاصة تحصل
          عليها من خلال مسار إلى 21 يونيكورن. يتم الكشف عن هذه المعلومات دون
          موافقة مسبقة من المستخدم، ولكن وفقًا لقوانين الخصوصية المعمول بها،
          والقانون الدولي، ومعايير حقوق الإنسان ومبادئ "عدم الضرر"؛
        </p>
        <p dir="rtl">
          الامتثال للقانون وحماية هداية وغيرها<strong>:</strong> امتثالًا
          لمعايير حقوق الإنسان الدولية ووفقًا لمبادئ "عدم الضرر"، يجوز لهداية
          والأطراف الأخرى الكشف عن معلوماتكم الشخصية وغيرها واستخدامها، إذا
          اعتقدنا أو اعتقدوا بشكل معقول أن هذا الإفشاء مطلوب من أجل (أ) تلبية أي
          قانون معمول به، أو لائحة، أو إجراء قانوني أو طلب حكومي، (ب) إنفاذ شروط
          الاستخدام المعمول بها، بما في ذلك التحقيق في الانتهاكات المحتملة لها،
          (ج) اكتشاف أو منع أو معالجة الأنشطة غير القانونية أو المشتبه بها (بما
          في ذلك الاحتيال في الدفع)، أو القضايا الأمنية أو الفنية أو (د) الحماية
          من إلحاق الضرر بحقوق، أو ممتلكات، أو سلامة هداية، أو مستخدمي الخدمات
          أو الجمهور، حسبما يقتضي القانون أو يسمح به؛
        </p>
        <ul>
          <li dir="rtl">أنتم، وعند الاقتضاء، ممثلوكم المعينون؛&nbsp;</li>
          <li dir="rtl">
            المحاسبون ومدققو الحسابات والمحامون وغيرهم من المستشارين المهنيين
            الخارجيين لهداية، مع مراعاة الالتزامات التعاقدية الملزمة بالسرية؛
          </li>
          <li dir="rtl">
            معالجات الأطراف الثالثة، الموجودة في أي مكان في العالم، وفقًا
            للمتطلبات المذكورة أدناه؛
          </li>
          <li dir="rtl">
            أي جهة (جهات) استحواذ خارجية ذات صلة، في حالة قيامنا ببيع أو نقل كل
            أو أي جزء ذي صلة من أعمالنا أو أصولنا (بما في ذلك في حالة إعادة
            التنظيم، أو الحل، أو التصفية)؛ وكذلك
          </li>
          <li dir="rtl">
            أي مقدم خدمة تابع لجهة خارجية، حيث تستخدم خدماتنا إعلانات أو مكونات
            إضافية أو محتوى تابعًا لجهة خارجية. إذا اخترتم التفاعل مع أي إعلان
            أو مكونات إضافية أو محتوى، فقد تتم مشاركة معلوماتكم الشخصية مع مزود
            خدمة الطرف الثالث ذي الصلة. نوصي بمراجعة سياسة الخصوصية الخاصة بهذا
            الطرف الثالث قبل التفاعل مع الإعلانات أو المكونات الإضافية أو
            المحتوى الخاص به.
          </li>
        </ul>
        <p dir="rtl">
          إذا قمنا باستخدام معالج تابع لجهة خارجية لمعالجة معلوماتكم الشخصية،
          فسيخضع المعالج لالتزامات تعاقدية ملزمة من أجل: (1) معالجة المعلومات
          الشخصية فقط وفقًا لتعليماتنا الكتابية السابقة؛ و(2) استخدام تدابير
          لحماية سرية وأمن المعلومات الشخصية؛ مع أي متطلبات إضافية بموجب القانون
          المعمول به.
        </p>
        <p dir="rtl">
          <em dir="rtl">النقل الدولي للمعلومات الشخصية</em>
        </p>
        <p dir="rtl">
          <em dir="rtl">
            نظرًا للطبيعة الدولية لأعمالنا، فإننا ننقل المعلومات الشخصية داخل
            مجموعة هداية، وإلى أطراف ثالثة كما هو مذكور في قسم "الكشف عن
            المعلومات" أعلاه، فيما يتعلق بالأغراض المنصوص عليها في بيان الخصوصية
            هذا. لهذا السبب، فإننا ننقل المعلومات الشخصية إلى دول أخرى قد تكون
            لديها قوانين ومتطلبات امتثال لحماية البيانات مختلفة عن تلك التي تطبق
            في البلد الذي تقيمون فيه.&nbsp;
          </em>
        </p>
        <p dir="rtl">
          <em dir="rtl">
            حين ننقل معلوماتكم الشخصية من المنطقة الاقتصادية الأوروبية إلى
            المستلمين الموجودين خارج المنطقة الاقتصادية الأوروبية الذين ليسوا في
            نطاق السلطات القضائية التي تم تعيينها رسميًّا من قِبَل المفوضية
            الأوروبية لتوفير مستوى مناسب من الحماية للمعلومات الشخصية (ما يسمى
            "الاختصاصات القضائية الملائمة")، فإننا نقوم بذلك وفقًا لتقديرنا
            الخاص.
          </em>
        </p>
        <p dir="rtl">
          <em dir="rtl">
            يرجى ملاحظة أنه عند نقل أي معلومات شخصية مباشرة إلى كيان هداية تم
            إنشاؤه خارج المنطقة الاقتصادية الأوروبية، فإننا لسنا مسؤولين عن هذا
            النقل لمعلوماتكم الشخصية. ومع ذلك، سنقوم بمعالجة معلوماتكم الشخصية،
            من اللحظة التي نتلقى فيها هذه البيانات، وفقًا لأحكام بيان الخصوصية
            هذا.
          </em>
        </p>
        <p dir="rtl">
          <em dir="rtl">دقة البيانات</em>
        </p>
        <p dir="rtl">
          <em dir="rtl">تتخذ هداية كل الخطوات المعقولة لضمان ما يلي:</em>
        </p>
        <ul>
          <li dir="rtl">
            <em dir="rtl">
              <em dir="rtl">
                أن تكون معلوماتكم الشخصية التي نعالجها دقيقة، وعند الضرورة يتم
                تحديثها؛ وكذلك
              </em>
            </em>
          </li>
        </ul>
        <ul>
          <li dir="rtl">
            <em dir="rtl">
              يتم مسح أو تصحيح أي من معلوماتكم الشخصية التي نعالجها والتي تكون
              غير دقيقة (مع مراعاة الأغراض التي تتم معالجتها من أجلها) دون
              تأخير.
            </em>
          </li>
        </ul>
        <p dir="rtl">
          <em dir="rtl">قد نطلب منكم من وقت لآخر تأكيد دقة معلوماتكم الشخصية.</em>
        </p>
        <p dir="rtl">
          <em dir="rtl">تقليل البيانات</em>
        </p>
        <p dir="rtl">
          تتخذ هداية كل خطوة معقولة للتأكد من أن معلوماتكم الشخصية التي نعالجها
          محدودة بالمعلومات الشخصية الضرورية{" "}
          <em dir="rtl">بشكل معقول فيما يتعلق بالأغراض المحددة في بيان الخصوصية هذا.</em>
        </p>
        <p dir="rtl">
          <em dir="rtl">استبقاء البيانات</em>
        </p>
        <p dir="rtl">
          <em dir="rtl">
            تتخذ هداية كل خطوة معقولة للتأكد من أن معلوماتكم الشخصية تتم
            معالجتها فقط للحد الأدنى من المدة اللازمة للأغراض المنصوص عليها في
            بيان الخصوصية هذا. وفيما يلي معايير تحديد المدة التي نحتفظ خلالها
            بمعلوماتكم الشخصية:&nbsp;
          </em>
        </p>
        <table>
          <tbody>
            <tr>
              <td>
                <ul>
                  <li dir="rtl">
                    <em dir="rtl">
                      نحتفظ بالمعلومات الشخصية بشكل يسمح بالتعريف فقط
                      طالما:&nbsp;
                    </em>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li dir="rtl">
                    <em dir="rtl">
                      نحافظ على علاقة مستمرة معكم (على سبيل المثال: عندما تكونون
                      مستخدمين لخدماتنا، أو يتم إدراجكم بشكل قانوني في قائمتنا
                      البريدية ولم تقوموا بإلغاء الاشتراك)؛ أو
                    </em>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li dir="rtl">
                    <em dir="rtl">
                      تكون معلوماتكم الشخصية ضرورية فيما يتعلق بالأغراض
                      القانونية المنصوص عليها في بيان الخصوصية هذا، والتي لدينا
                      أساس قانوني صالح لها (على سبيل المثال: حيث يتم تضمين
                      بياناتكم الشخصية في عقد بيننا وبين صاحب العمل، ولدينا
                      مصلحة مشروعة في معالجة هذه البيانات لأغراض تشغيل أعمالنا
                      والوفاء بالتزاماتنا بموجب ذلك العقد؛ أو عندما يكون لدينا
                      التزام قانوني بالاحتفاظ بمعلوماتكم الشخصية)،
                    </em>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="rtl">
                  <strong>
                    <em dir="rtl">بالإضافة إلى:</em>
                  </strong>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li dir="rtl">
                    <em dir="rtl">مدة:</em>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li dir="rtl">
                    <em dir="rtl">
                      أي فترة تقييد سارية بموجب القانون المعمول به (بمعنى أي
                      فترة يمكن لأي شخص خلالها رفع دعوى قانونية ضدنا فيما يتعلق
                      بمعلوماتكم الشخصية، أو التي تتعلق بها معلوماتكم الشخصية)،
                      وكذلك
                    </em>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li dir="rtl">
                    <em dir="rtl">
                      فترة شهرَين (2) إضافية بعد انتهاء فترة التقادم المطبقة
                      (بحيث إذا قدم شخص مطالبة في نهاية فترة التقادم، فلا تزال
                      لدينا فترة زمنية معقولة لتحديد أي معلومات شخصية ذات صلة
                      بهذا الادعاء)،
                    </em>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="rtl">
                  <strong>
                    <em dir="rtl">وكذلك:</em>
                  </strong>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li dir="rtl">
                    <em dir="rtl">
                      بالإضافة إلى ذلك، إذا تم تقديم أي مطالبات قانونية ذات صلة،
                      فإننا نواصل معالجة المعلومات الشخصية لفترات إضافية ضرورية
                      فيما يتعلق بتلك المطالبة.
                    </em>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <p dir="rtl">
          <em dir="rtl">
            خلال الفترات المشار إليها في الفقرات (2) (أ) و(2) (ب) أعلاه،
            سنُقْصِر معالجتنا لمعلوماتك الشخصية على تخزين تلك البيانات والحفاظ
            على أمانها، باستثناء الحد الذي تحتاج فيه هذه البيانات إلى المراجعة
            فيما يتعلق بأي مطالبة قانونية، أو أي التزام بموجب القانون المعمول
            به.
          </em>
        </p>
        <p dir="rtl">
          <em dir="rtl">
            بمجرد انتهاء الفترات في الفقرات (1)، و(2)، و(3) أعلاه، وإلى الحد
            الذي ينطبق، سنقوم إما:
          </em>
        </p>
        <ul>
          <li dir="rtl">
            <em dir="rtl">
              <em dir="rtl">بحذف المعلومات الشخصية ذات الصلة أو إتلافها نهائيًّا؛ أو</em>
            </em>
          </li>
        </ul>
        <ul>
          <li dir="rtl">
            <em dir="rtl">إخفاء هوية المعلومات الشخصية ذات الصلة.</em>
          </li>
        </ul>
        <p dir="rtl">
          <em dir="rtl">الوصول إلى حسابكم وملفات التعريف</em>
        </p>
        <p dir="rtl">
          من أجل تزويدكم بسهولة الوصول إلى حسابكم وللمساعدة في إدارة مسار وتوفير
          الخدمات، نستخدم التكنولوجيا التي تمكِّننا من التعرف عليكم بصفتكم صاحب
          الحساب وتزويدكم بوصول مباشر إلى حسابكم دون مطالبتكم بإعادة كتابة أي
          كلمة مرور أو تعريف المستخدم الآخر عند الوصول إلى الخدمات.&nbsp;
        </p>
        <p dir="rtl">
          <em dir="rtl">اختياراتكم</em>
        </p>
        <p dir="rtl">
          يمكنكم الاشتراك لتلقِّي إشعارات الدفع عبر الجوال من مسار. إذا قررتم
          فيما بعد أنكم لم تعودوا ترغبون في تلقِّي هذه الإشعارات، فيمكنكم
          استخدام وظيفة إعدادات جهازكم المحمول لإيقاف تشغيلها.
        </p>
        <p dir="rtl">
          <em dir="rtl">معلوماتكم وحقوقكم</em>
        </p>
        <p dir="rtl">
          يمكنكم طلب الوصول إلى معلوماتكم الشخصية ونسخها، أو طلب تصحيح أي
          معلومات شخصية قديمة أو غير دقيقة نحتفظ بها.
        </p>
        <p dir="rtl">
          يمكنكم القيام بذلك بسهولة عن طريق زيارة قسم الملف الشخصي على موقعنا،
          حيث يمكنكم الوصول إلى بعض المعلومات المتعلقة بحسابكم وتحديثها، كما يجب
          تسجيل الدخول للوصول إلى ملفكم الشخصي. يمكنكم أيضًا أن تطلبوا، لأسباب
          قانونية، حذف المعلومات الشخصية التي نحتفظ بها عن طريق حذف
          حسابكم.&nbsp;
        </p>
        <p dir="rtl">
          لديكم الحق في نقل بعض معلوماتكم الشخصية إلى وحدة تحكم أخرى في
          البيانات، بتنسيق منظم، شائع الاستخدام وقابل للقراءة آليًّا، إلى أقصى
          حد ممكن. عندما نعالج معلوماتكم الشخصية على أساس موافقتكم، يحق لكم سحب
          تلك الموافقة (مع ملاحظة أن هذا السحب لا يؤثر في قانونية أي معالجة تتم
          قبل التاريخ الذي نتلقى فيه إشعارًا بهذا السحب، ولا يمنع معالجة
          معلوماتكم الشخصية بالاعتماد على أي قواعد قانونية أخرى متاحة).
        </p>
        <p dir="rtl">
          لتقديم الطلبات، أو إذا كان لديكم أي سؤال آخر بخصوص ممارسات الخصوصية
          لدينا، يرجى الاتصال بنا على{" "}
          <a href="mailto:masar@hedayah.ae">masar@hedayah.ae</a>، ويرجى أيضًا
          الاطلاع على قسم اختياراتكم من بيان الخصوصية هذا للحصول على حقوق
          وخيارات إضافية تتعلق بمعلوماتكم.
        </p>
        <p dir="rtl">
          قد نرفض الطلبات غير المعقولة أو غير المطلوبة بموجب القانون، بما في ذلك
          الطلبات التي ستكون غير عملية للغاية، والتي قد تتطلب جهدًا فنيًّا غير
          متناسب، أو قد تعرِّضنا لمخاطر تشغيلية مثل الاحتيال التجريبي المجاني.
        </p>
        <p dir="rtl">
          لديكم أيضًا الحق في تقديم الشكاوى المتعلقة بمعالجة معلوماتكم الشخصية
          مع سلطة حماية البيانات (على وجه الخصوص، سلطة حماية البيانات في الدولة
          العضو في الاتحاد الأوروبي التي تعيشون فيها، أو التي تعملون فيها، أو
          التي حدث فيها الانتهاك المزعوم، أيها ينطبق).
        </p>
        <table>
          <tbody>
            <tr>
              <td>
                <p dir="rtl">
                  <strong>
                    وفقًا للقانون المعمول به، قد تكون لديكم أيضًا الحقوق
                    الإضافية التالية فيما يتعلق بمعالجة معلوماتكم الشخصية:
                  </strong>
                </p>
                <ul>
                  <li dir="rtl">
                    <strong>
                      الحق في الاعتراض، لأسباب تتعلق بوضعكم الخاص، على معالجة
                      معلوماتكم الشخصية من قِبَلنا أو نيابةً عنا؛ وكذلك
                    </strong>
                  </li>
                  <li dir="rtl">
                    <strong>
                      الحق في الاعتراض على معالجة معلوماتكم الشخصية من قِبَلنا
                      أو نيابةً عنا لأغراض التسويق المباشر.
                    </strong>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <p dir="rtl">
          سيؤدي الاعتراض على معالجة البيانات إلى إنهاء وصولكم إلى الخدمات وسيتم
          حذف حسابكم.
        </p>
        <p dir="rtl">
          <em dir="rtl">أمن معلوماتكم الشخصية.&nbsp;</em>
        </p>
        <p dir="rtl">
          نحن نستخدم تدابير الأمن الإدارية، والمنطقية، والمادية، والإدارية
          المناسبة لحماية معلوماتكم الشخصية من الضياع، والسرقة، والحوادث
          العرضية، أو غير المصرح بها، والتدمير، والكشف، والوصول، والاستخدام،
          والتعديل، وفقًا للقانون المعمول به. لسوء الحظ، لا يمكن ضمان اتخاذ أي
          تدابير لتوفير الأمان بنسبة 100٪.&nbsp;
        </p>
        <p dir="rtl">
          <em dir="rtl">
            لأن الإنترنت هو نظام مفتوح، فإن نقل المعلومات عبر الإنترنت ليس آمنًا
            تمامًا. وعلى الرغم من أننا سنتخذ جميع التدابير المعقولة لحماية
            معلوماتكم الشخصية، فإنه لا يمكننا ضمان أمن بياناتكم المرسلة إلينا
            باستخدام الإنترنت - أي عملية إرسال تكون على مسؤوليتكم الخاصة، وأنتم
            مسؤولون عن ضمان أن أي معلومات شخصية ترسلونها إلينا ستقومون بإرسالها
            بشكل آمن.
          </em>
        </p>
        <p dir="rtl">
          <em dir="rtl">مواقع، ومنصات، وتطبيقات أخرى</em>
        </p>
        <p dir="rtl">
          قد يتم تقديم الخدمات من خلال و/أو الاستفادة من الميزات (مثل عناصر
          التحكم في الصوت) التي يتم تشغيلها بواسطة منصات جهات خارجية، أو تحتوي
          على روابط لمواقع يتم تشغيلها بواسطة أطراف أخرى قد تختلف سياساتها فيما
          يتعلق بمعالجة المعلومات عن سياساتنا، فعلى سبيل المثال: قد تتمكن من
          الوصول إلى الخدمات من خلال أنظمة أساسية مثل أنظمة الألعاب، وأجهزة
          التلفزيون الذكية، والأجهزة المحمولة، وأجهزة الاستقبال، وعدد من الأجهزة
          الأخرى المتصلة بالإنترنت. تحتوي هذه المواقع والمنصات على سياسات خصوصية
          وسياسات بيانات، وبيانات خصوصية، وإشعارات، وشروط استخدام منفصلة
          ومستقلة، والتي نوصي بقراءتها بعناية. وبالإضافة إلى ذلك، قد تواجه
          تطبيقات طرف ثالث تتفاعل مع مسار.
        </p>
        <p dir="rtl">
          <em dir="rtl">الأطفال</em>
        </p>
        <p dir="rtl">
          يجب أن يكون عمرك 18 عامًا أو أكثر للاشتراك في مسار. في بعض الولايات
          القضائية، قد يكون سن الرشد أكبر من 18 عامًا، وفي هذه الحالة، يجب أن
          تفي بهذا الشرط لكي تصبح عضوًا.
        </p>
        <p dir="rtl">إجراء تغييرات على هذا البيان</p>
        <p dir="rtl">
          سنقوم بتحديث بيان الخصوصية هذا من وقت لآخر استجابةً للمتطلبات
          القانونية، أو التنظيمية، أو التشغيلية المتغيرة. إن استمرار استخدامكم
          لمسار بعد تفعيل أي من هذه التحديثات سوف يعتبر قبولًا لهذه التغييرات.
          إذا لم تقبلوا أي تحديثات لبيان الخصوصية هذا، فيمكنكم إلغاء استخدامكم
          لمسار. لمعرفة متى تم آخر تحديث لبيان الخصوصية، يرجى مراجعة قسم "آخر
          تحديث" أدناه.
        </p>
        <p dir="rtl">
          التحديث الأخير<strong>:</strong> 16 أغسطس 2018
        </p>
        <p dir="rtl">
          لرؤية النسخة السابقة من هذا المستند، يرجى الذهاب إلى{" "}
          <a href="https://www.masar.tech/privacyupdates">
            www.masar.tech/privacyupdates
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Container;



// WEBPACK FOOTER //
// ./src/routers/ARTerms.js